import { Label } from "@/components/ui/label";
import { useEmailSuggestions } from "./hooks/useEmailSuggestions";
import { useCurrentUserEmail } from "./hooks/useCurrentUserEmail";
import PrimaryEmailInput from "./components/PrimaryEmailInput";
import { SecondaryEmailsList } from "./components/SecondaryEmailsList";
import SecondaryEmailInput from "./components/SecondaryEmailInput";
import { useState } from "react";

interface EmailManagementProps {
  primaryEmail: string;
  secondaryEmails: string[];
  isSubmitting?: boolean;
  onPrimaryEmailChange: (email: string) => void;
  onSecondaryEmailsChange: (emails: string[]) => void;
}

export const EmailManagement = ({
  primaryEmail,
  secondaryEmails,
  isSubmitting = false,
  onPrimaryEmailChange,
  onSecondaryEmailsChange,
}: EmailManagementProps) => {
  const emailSuggestions = useEmailSuggestions();
  const currentUserEmail = useCurrentUserEmail(primaryEmail, onPrimaryEmailChange);
  const [secondaryInput, setSecondaryInput] = useState("");

  // Permet d'ajouter UN SEUL email à la fois
  const addSecondaryEmail = (email: string) => {
    const emailTrimmed = email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      emailTrimmed &&
      emailRegex.test(emailTrimmed) &&
      !secondaryEmails.includes(emailTrimmed) &&
      emailTrimmed !== primaryEmail
    ) {
      onSecondaryEmailsChange([...secondaryEmails, emailTrimmed]);
      setSecondaryInput("");
    }
  };

  const removeSecondaryEmail = (emailToRemove: string) => {
    onSecondaryEmailsChange(secondaryEmails.filter(email => email !== emailToRemove));
  };

  return (
    <div className="space-y-4">
      <PrimaryEmailInput
        value={primaryEmail}
        onChange={onPrimaryEmailChange}
        disabled={isSubmitting}
        placeholder="Email principal"
      />

      <div className="space-y-2">
        <Label>Emails secondaires</Label>

        <SecondaryEmailsList
          secondaryEmails={secondaryEmails}
          isSubmitting={isSubmitting}
          onRemoveEmail={removeSecondaryEmail}
        />

        <div className="flex items-center space-x-2">
          <SecondaryEmailInput
            value={secondaryInput}
            onChange={setSecondaryInput}
            disabled={isSubmitting}
            placeholder="Ajouter un email secondaire"
          />
          <button
            className="bg-primary text-white px-3 py-2 rounded disabled:opacity-50"
            onClick={() => addSecondaryEmail(secondaryInput)}
            disabled={
              isSubmitting ||
              !secondaryInput.trim() ||
              secondaryEmails.includes(secondaryInput.trim()) ||
              secondaryInput.trim() === primaryEmail
            }
            type="button"
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  );
};
